import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import useNavigation from '../hooks/useNavigation';

const Footer = () => {
  const { navigateTo } = useNavigation();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Om oss</h3>
          <p>Vi säljer ett kompakt digitalt transkriptionsverktyg som låter användare förladda anteckningar och trådlöst överföra dem till en dator via Bluetooth.</p>
        </div>
        <div className="footer-section">
          <h3>Snabblänkar</h3>
          <ul>
            <li><Link to="/" onClick={navigateTo('/')}>Hem</Link></li>
            <li><Link to="/policy" onClick={navigateTo('/policy')}>Policy</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Kontakta oss</h3>
          <p>Email: contact.essaywriter@gmail.com</p>
          <p>
            <a 
              href="https://discord.gg/MskmVMUBgr" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-link"
            >
              Discord
            </a>
          </p>
          <p>
            <a 
              href="https://www.instagram.com/essaywriterswe" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-link"
            >
              Instagram
            </a>
          </p>
          <p>
            <a 
              href="https://www.tiktok.com/@essaywriterswe" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-link"
            >
              TikTok
            </a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} EssayWriter</p>
      </div>
    </footer>
  );
};

export default Footer;